module.exports = __webpack_public_path__ + "img/vi.0aa78210.svg";